<template>
  <modal :id="id" :classes="classes" :max-width="maxWidth">
    <div class="modal-content">
      <div class="modal-header bg-primary d-flex text-white align-items-center">
        <h5 class="modal-title">
          <i v-if="icon" :class="icon" class="mr-2 fa-lg"></i>
          <slot name="title"></slot>
        </h5>
        <i data-dismiss="modal" class="fa-lg fas fa-times cursor-pointer"></i>
      </div>
      <div class="modal-body" :class="bodyClasses">
        <slot name="content"></slot>
      </div>
      <div class="modal-footer bg-light py-2">
        <slot name="footer"></slot>
      </div>
    </div>
  </modal>
</template>

<script>
  import Modal from './Modal'

  export default {
    components: {
      Modal,
    },
    props: {
      id: {
        type: String,
        required: true
      },
      maxWidth: {
        type: String,
        default: '2xl'
      },
      icon: String,
      bodyClasses: String,
      classes: String
    }
  }
</script>
